import consolv from 'lib/consolv';

const defaultConfig = {
  findOutOfPageAdSlots: {
  },
};

/**
 * Finds ad slots on the page load and initializes them
 * @param {MCPInstance} MCP - Reference to the MCP instance
 * @param {Object} params
 * @param {Function} params.addAsyncEvent Function provided by event dispatcher to add asynchronous
 * functions before continuing current processing thread
 */
export function findOutOfPageAdSlots(MCP, { addAsyncEvent }) {
  const configuration = MCP.Configurator.getConfigurationAsync({ defaults: defaultConfig });

  const waitForGoogleTag = new Promise((resolve) => {
    window.googletag.cmd.push(() => { resolve(window.googletag); });
  });

  return Promise.all([waitForGoogleTag, configuration]).then(([googletag, config]) => {
    const { OutOfPageFormat } = googletag.enums;
    const { findOutOfPageAdSlots: findSlots } = config;
    const newAdSlots = [];

    Object.keys(findSlots).forEach((slotName) => {
      const slotConfig = findSlots[slotName];
      let { type } = slotConfig;
      if (type === 'googleInterstitial') type = OutOfPageFormat.INTERSTITIAL;

      const slot = MCP._defineOutOfPageAdSlot(type, slotName);

      newAdSlots.push(slot);
    });

    if (!newAdSlots.length) return null;

    return Promise.all(newAdSlots).then((resolvedSlots) => {
      const nativeSlots = resolvedSlots.map(slot => slot._DFPSlot);
      window.googletag.pubads().refresh(nativeSlots);
      consolv.log('MCP: Loaded Out of Page slots', resolvedSlots);
    });
  });
}

export default function setupFindOutOfPageAdSlots(MCP) {
  MCP.addEventListener('initialized', (e) => { findOutOfPageAdSlots(MCP, e); });
}
